export const pluralize = (number, one, many, zero = many) => {
	if (number === 1) {
		return one;
	}
	if (!number) {
		return zero;
	}
	return many;
};
